module.exports = __webpack_public_path__ + "img/settings_small.a2192381.svg";